import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", { d: "m17.828 3.343 2.829 2.829-8.485 8.485-2.829-2.829 8.485-8.485Zm1.415-1.414a2 2 0 0 1 2.828 2.828l-.707.708-2.829-2.829.708-.707ZM7.929 16.071l3.535-.707-2.828-2.828-.707 3.535Z" }, null, -1), l = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M7.223 16.935a.5.5 0 0 1-.431.56c-.698.092-1.749.443-2.5.906-.38.235-.625.463-.733.65a.348.348 0 0 0-.059.182c.001.033.012.086.072.164.063.082.23.189.64.224.396.034.915-.008 1.535-.108.914-.147 1.965-.406 3.045-.673.388-.095.779-.191 1.169-.284 1.434-.34 2.884-.637 3.918-.546.516.045 1.045.195 1.384.603.355.427.39.996.236 1.61a.363.363 0 0 0-.011.132v.001l.003.004a.431.431 0 0 0 .126.066c.25.086.701.102 1.323.023 1.211-.153 2.77-.621 3.875-1.062a.5.5 0 1 1 .37.93c-1.153.46-2.798.957-4.12 1.124-.645.082-1.293.096-1.773-.07-.25-.086-.505-.238-.664-.505-.163-.275-.173-.587-.098-.886.115-.46.03-.647-.036-.728-.083-.1-.28-.209-.702-.246-.845-.074-2.133.175-3.6.523-.367.087-.744.18-1.123.273-1.092.27-2.205.544-3.163.699-.647.104-1.261.16-1.778.116-.503-.043-1.027-.19-1.35-.611a1.276 1.276 0 0 1-.277-.741 1.338 1.338 0 0 1 .192-.714c.231-.4.644-.735 1.075-1.001.872-.538 2.057-.937 2.894-1.046a.5.5 0 0 1 .56.431Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  n,
  l
];
function d(r, s) {
  return t(), o("svg", c, [...a]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
